import { MouseEvent, PropsWithChildren } from 'react'

export interface LinkProps extends PropsWithChildren {
  className?: string
  onClick: (event: MouseEvent<HTMLDivElement>) => void
}

export const Link = ({ className = '', children, onClick }: LinkProps) => {
  return (
    <div className={`cursor-pointer ${className}`} onClick={onClick}>
      {children}
    </div>
  )
}
